import React from 'react';
import { Phone, Mail } from 'lucide-react';

const DakoFooter = () => {
  return (
    <footer className="bg-gradient-to-br from-purple-600 via-blue-600 to-cyan-500 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 mb-8 max-w-3xl mx-auto">
            {/* Contact */}
            <div>
              <h4 className="text-lg font-bold mb-4">Kontakt</h4>
              <div className="space-y-3 text-sm">
                <a
                  href="tel:774750456"
                  className="flex items-center space-x-2 text-white/90 hover:text-white transition-colors"
                >
                  <Phone className="w-4 h-4" />
                  <span>774 750 456 (Catering)</span>
                </a>
                <a
                  href="tel:773550880"
                  className="flex items-center space-x-2 text-white/90 hover:text-white transition-colors"
                >
                  <Phone className="w-4 h-4" />
                  <span>773 550 880 (Produkce)</span>
                </a>
                <a
                  href="mailto:info@vseproakci.cz"
                  className="flex items-center space-x-2 text-white/90 hover:text-white transition-colors"
                >
                  <Mail className="w-4 h-4" />
                  <span>info@vseproakci.cz</span>
                </a>
              </div>
            </div>
            
            {/* Event Info */}
            <div>
              <h4 className="text-lg font-bold mb-4">Akce</h4>
              <div className="text-sm text-white/90 space-y-2">
                <p className="font-semibold text-white">30. výročí firmy</p>
                <p>DAKO a.s.</p>
              </div>
            </div>
          </div>
          
          <div className="border-t border-white/20 pt-8">
            <div className="flex flex-col items-center space-y-4">
              <img
                src="https://customer-assets.emergentagent.com/job_vsepro-wanzl/artifacts/u5gbllyr_4t7rchw6_VPA-logo-white.png"
                alt="VšeProAkci"
                className="h-14"
              />
              <p className="text-white/80 text-sm">
                © {new Date().getFullYear()} VšeProAkci. Profesionální organizace firemních akcí.
              </p>
              <p className="text-white/70 text-xs">
                Tato nabídka je platná do 11. 4. 2026
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default DakoFooter;
